import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {IndexComponent as indexFinger} from './components/finger/index/index.component';
import {IndexComponent as indexFace} from './components/face/index/index.component';
import {DeviceDetectorGuard} from './guards/device-detector.guard';
import { AuthGuard } from './guards/auth-guard-service ';

const routes: Routes = [
  {
    path: 'finger', component: indexFinger, canActivate: [AuthGuard]
  },
  {
    path: 'auth/finger', component: indexFinger, canActivate: [AuthGuard]
  },
  {
    path: 'dashboard/finger', component: indexFinger, canActivate: [AuthGuard]
  },
  {
    path: 'face', component: indexFace, canActivate: [AuthGuard]
  },
  {
    path: 'dashboard/face', component: indexFace, canActivate: [AuthGuard]
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'login-desktop',
    loadChildren: () => import('./pages/login-desktop/login-desktop.module').then(m => m.LoginDesktopPageModule),
    canLoad: [DeviceDetectorGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard/ine',
    loadChildren: () => import('./pages/ine/ine.module').then(m => m.InePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'aviso-privacidad',
    loadChildren: () => import('./pages/aviso-privacidad/aviso-privacidad.module').then(m => m.AvisoPrivacidadPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'verificar-cliente',
    loadChildren: () => import('./pages/verificar-cliente/verificar-cliente.module').then(m => m.VerificarClientePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'correo-electronico-contrato',
    loadChildren: () => import('./pages/correo-electronico-contrato/correo-electronico-contrato.module').then(m => m.CorreoElectronicoContratoPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ine-data',
    loadChildren: () => import('./pages/ine-data/ine-data.module').then(m => m.IneDataPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'guardar-enrolamiento',
    loadChildren: () => import('./pages/guardar-enrolamiento/guardar-enrolamiento.module').then(m => m.GuardarEnrolamientoPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'otp',
    loadChildren: () => import('./pages/otp/otp.module').then(m => m.OtpPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'pasaporte',
    loadChildren: () => import('./pages/pasaporte/pasaporte.module').then(m => m.PasaportePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'forma-migratoria',
    loadChildren: () => import('./pages/forma-migratoria/forma-migratoria.module').then(m => m.FormaMigratoriaPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'register-user',
    loadChildren: () => import('./pages/register-user/register-user.module').then(m => m.RegisterUserPageModule)
  },
  {
    path: 'seleccionar-doc',
    loadChildren: () => import('./pages/seleccionar-doc/seleccionar-doc.module').then(m => m.SeleccionarDocPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'validar-rfc',
    loadChildren: () => import('./pages/validar-rfc/validar-rfc.module').then(m => m.ValidarRfcPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'bandeja-contratos',
    loadChildren: () => import('./pages/bandeja-contratos/bandeja-contratos.module').then(m => m.BandejaContratosPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'aviso-privacidad-text',
    loadChildren: () => import('./pages/aviso-privacidad-text/aviso-privacidad-text.module').then(m => m.AvisoPrivacidadTextPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'cedula-profesional',
    loadChildren: () => import('./pages/cedula-profesional/cedula-profesional.module').then(m => m.CedulaProfesionalPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'expediente',
    loadChildren: () => import('./pages/expediente/expediente.module').then(m => m.ExpedientePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'document-scan',
    loadChildren: () => import('./pages/document-scan/document-scan.module').then(m => m.DocumentScanPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'mitek',
    loadChildren: () => import('./pages/mitek/mitek.module').then(m => m.MitekPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard/face2',
    loadChildren: () => import('./pages/face-mitek/face-mitek.module').then(m => m.FaceMitekPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'enrollment/search',
    loadChildren: () => import('./pages/searching-enroll/search-enrollment/search-enrollment.module').then(m => m.SearchEnrollmentModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'enrollment/search-result',
    loadChildren: () => import('./pages/searching-enroll/result-search-enrollment/result-search-enrollment.module').then(m => m.ResultSearchEnrollmentModule),
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
